import { MAP_TYPES } from '@deck.gl/carto';

const CURRENTFLOODZONES_SOURCE_ID = 'currentFloodZonesSource';

const source = {
  id: CURRENTFLOODZONES_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'bmpo-smartmetro-09142026',
  data: 'SELECT * FROM `us-con-gcp-npr-0000424-011325.diamond.Broward_County_Flood_Zones_2024` WHERE Flood_Zone_Designation_Description IN ("1% Annual Chance Flood Hazard", "0.2% Annual Chance Flood Hazard")',
  geoColumn: 'geom',
};

export default source;
